<template>
  <div class="page-header">
    <div class="row">
      <div class="col">
        <h3 class="page-title">{{ title }}</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="admin-dashboard">{{ path }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="employees">{{ text }}</router-link>
          </li>
          <li class="breadcrumb-item active">{{ text1 }}</li>
        </ul>
      </div>
      <div class="col-auto float-end ms-auto" v-if="isShiftSchedulingRoute">
        <!-- <a
          class="list-view btn btn-link btn-primary mr-3"
          data-bs-toggle="modal"
          data-bs-target="#daliy_schedule_manage_colvis"
          style="margin-right: 5px"
          title="colvis"
          v-if="isShiftSchedulingRoute"
          ><i class="fa-solid fa-bars"></i
        ></a> -->
        <a
          class="btn btn-primary m-r-5"
          style="border-radius: 50px"
          @click="exportReport('export-shift-scheduling')"
          v-if="hasScheduleExportPermission"
        >
          {{ text5 }}</a
        >
        <router-link
          v-if="hasShiftReadPermission"
          to="shift-list"
          class="btn add-btn m-r-5 mb-1"
          >{{ text2 }}</router-link
        >
        <!-- Copy Week Dropdown -->
        <div class="btn-group m-r-5" v-if="hasScheduleExportPermission">
          <button
            type="button"
            class="btn add-btn dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Copy Week
          </button>
          <ul class="dropdown-menu">
            <li>
              <span class="dropdown-item text-muted disabled">
                {{ formattedCurrentWeek }}
              </span>
            </li>
            <li v-for="(week, index) in weekOptions" :key="index">
              <a
                class="dropdown-item"
                href="javascript:;"
                @click="copyWeek(week)"
              >
                {{ week.label }}
              </a>
            </li>
          </ul>
        </div>
        <a
          href="javascript:;"
          class="btn add-btn m-r-5 mb-1"
          data-bs-toggle="modal"
          data-bs-target="#add_schedule"
          v-if="hasScheduleCreatePermission"
        >
          {{ text3 }}</a
        >
        <a
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_dept_schedule"
          v-if="hasScheduleCreatePermission"
        >
          {{ text4 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isShiftListRoute">
        <a
          @click="onAddShift"
          v-if="hasShiftCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_shift"
          >{{ text2 }}</a
        >
        <a
          @click="onAddSchedule"
          v-if="hasScheduleCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_schedule"
        >
          {{ text3 }}</a
        >
        <a
          @click="onAddDeptSchedule"
          v-if="hasScheduleCreatePermission"
          href="javascript:;"
          class="btn add-btn m-r-5"
          data-bs-toggle="modal"
          data-bs-target="#add_dept_schedule"
        >
          {{ text4 }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  emits: ["add-shift", "add-schedule", "add-dept-schedule", "copy-week"],
  props: {
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
    text2: {
      type: String,
      default: "",
    },
    text3: {
      type: String,
      default: "",
    },
    text4: {
      type: String,
      default: "",
    },
    text5: {
      type: String,
      default: "",
    },
    currentWeekStart: {
      type: String,
      required: true,
    },
    currentWeekEnd: {
      type: String,
      required: true,
    },
    search_data: { type: Object, default: null, required: false },
    columns: { type: Array, default: null, required: false },
  },
  data() {
    return {
      hasShiftCreatePermission: null,
      hasShiftReadPermission: null,
      hasScheduleCreatePermission: null,
      hasScheduleExportPermission: null,
      weekOptions: [],
    };
  },
  computed: {
    isShiftSchedulingRoute() {
      return this.$route.path === "/shift-scheduling";
    },
    isShiftListRoute() {
      return this.$route.path === "/shift-list";
    },
    formattedCurrentWeek() {
      return `Copy ${moment(this.currentWeekStart).format("MMM DD")} - ${moment(
        this.currentWeekEnd
      ).format("MMM DD")} to:`;
    },
  },
  methods: {
    onAddShift() {
      this.$emit("add-shift");
    },
    onAddSchedule() {
      this.$emit("add-schedule");
    },
    onAddDeptSchedule() {
      this.$emit("add-dept-schedule");
    },
    exportReport(report) {
      console.log(report);

      var searchData = null;
      var col_params = null;
      var url = `${process.env.VUE_APP_API_BASE_URL}report/${report}`;

      console.log(url);

      if (this.search_data && this.search_data != null) {
        searchData = Object.keys(this.search_data)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(
                this.search_data[key]
              )}`
          )
          .join("&");
      }

      if (this.columns?.length) {
        var columns_keys = this.columns.map((column) => column.key);
        col_params = new URLSearchParams({
          keys: columns_keys.join(","),
        }).toString();
      }

      if (searchData != null) {
        url = `${process.env.VUE_APP_API_BASE_URL}report/${report}?${searchData}`;

        if (col_params != null) {
          url += `&${col_params}`;
        }
      } else {
        if (col_params != null) {
          url = `${process.env.VUE_APP_API_BASE_URL}report/${report}?${col_params}`;
        }
      }
      window.location.href = url;
    },
    generateWeekOptions() {
      const options = [];
      const currentStart = moment(this.currentWeekStart);

      for (let i = 1; i <= 3; i++) {
        const start = moment(currentStart).add(i * 7, "days");
        options.push({
          type: "future",
          startDate: start.format("YYYY-MM-DD"),
          endDate: moment(start).add(6, "days").format("YYYY-MM-DD"),
          label: `${start.format("MMM DD")} - ${moment(start)
            .add(6, "days")
            .format("MMM DD")}`,
        });
      }

      this.weekOptions = options;
    },

    copyWeek(week) {
      this.$emit("copy-week", {
        startDate: week.startDate,
        endDate: week.endDate,
      });
    },
  },
  watch: {
    currentWeekStart() {
      this.generateWeekOptions();
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", { module: "shift", action: "create" })
      .then((response) => {
        this.hasShiftCreatePermission = null;
        this.$nextTick(() => {
          this.hasShiftCreatePermission = response === "true";
        });
      });
    this.$store
      .dispatch("userPermissions", { module: "shift", action: "read" })
      .then((response) => {
        this.hasShiftReadPermission = null;
        this.$nextTick(() => {
          this.hasShiftReadPermission = response === "true";
        });
      });
    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "create" })
      .then((response) => {
        this.hasScheduleCreatePermission = null;
        this.$nextTick(() => {
          this.hasScheduleCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "schedule", action: "export" })
      .then((response) => {
        this.hasScheduleExportPermission = null;
        this.$nextTick(() => {
          this.hasScheduleExportPermission = response === "true";
        });
      });

    this.generateWeekOptions();
  },
};
</script>
